<ng-container *ngIf="{ selectedSystemDefinition: selectedSystemDefinition$ | async } as resolved">
  <lib-device-list
    id="device-list"
    class="custom-block"
    [labels]="{
      actions: labels.actions,
      evChCharging: labels.evChCharging,
      evChError: labels.evChError,
      evChIdle: labels.evChIdle,
      evChParking: labels.evChParking,
      evChUnknown: labels.evChUnknown,
      logger: labels.logger,
      noActions: labels.noActions,
      noDevice: labels.noDevice,
      serial: labels.serial,
      status: labels.status,
      statusConnected: labels.statusConnected,
      statusDisconnected: labels.statusDisconnected,
      statusNotUpdated: labels.statusNotUpdated,
      statusUpdated: labels.statusUpdated,
      statusUninstalled: labels.statusUninstalled,
      title: labels.title,
      type: labels.type,
    }"
    [refresh$]="refresh$"
    [system]="system"
    [compareMode]="compareMode"
    [selectedDevicesForComparison]="selectedDevicesForComparison"
    (view)="goToDevicePage.emit($event)"
    (compare)="compare.emit($event)"
    (inverterCountChange)="inverterCountChange.emit($event)">
    <customer-header-options
      *ngIf="resolved.selectedSystemDefinition?.metadata?.userLevel"
      add-device>
      <customer-header-options-item
        data-testid="device-management-button"
        [accent]="true"
        (click)="resolved.selectedSystemDefinition && openAddDeviceDialog(resolved.selectedSystemDefinition)">
        <mat-icon> devices </mat-icon>
        <span> {{ labels.addRemove }} </span>
      </customer-header-options-item>
    </customer-header-options>
  </lib-device-list>

  <ng-template
    #connextDevices
    let-data>
    <section class="custom-block">
      <ng-container *ngTemplateOutlet="header; context: { title: labels.modifyPlant }"></ng-container>
      <customer-connext-devices-section
        class="mt-3"
        [labels]="{
          active: labels.active,
          applyRegistration: labels.applyRegistration,
          certifiedPlantsInverters: labels.certifiedPlantsInverters,
          certifiedPlantsInvertersDescription: labels.certifiedPlantsInvertersDescription,
          connextsInverters: labels.connextsInverters,
          delete: labels.delete,
          error: labels.error,
          inverterListDescription: labels.inverterListDescription,
          inverterListPlaceholder: labels.inverterListPlaceholder,
          inverterModbusDescription: labels.inverterModbusDescription,
          inverterModbusDescriptionInnerCard: labels.inverterModbusDescriptionInnerCard,
          inverterModbusPlaceholder: labels.inverterModbusPlaceholder,
          inverterRegistrationError: labels.inverterRegistrationError,
          inverters: labels.inverters,
          multiplicativeConstant: labels.multiplicativeConstant,
          productionSensor: labels.productionSensor,
          productionSensorDesc: labels.productionSensorDesc,
          productionSensorDescWithConstMultiplicative: labels.productionSensorDescWithConstMultiplicative,
          productionSensorPlaceholder: labels.productionSensorPlaceholder,
          registered: labels.registered,
          restore: labels.restore,
          restoreDevicesAndSensors: labels.restoreDevicesAndSensors,
          restoreDevicesAndSensorsDescription: labels.restoreDevicesAndSensorsDescription,
          sensorRegistrationError: labels.sensorRegistrationError,
          sensors: labels.sensors,
          setup: labels.setup,
          uninstall: labels.uninstall,
          uninstalled: labels.uninstalled,
        }"
        [isVerifiedMode]="resolved.selectedSystemDefinition?.source === 'aws'"
        [certifiedPlantDevices]="resolved.selectedSystemDefinition?.metadata?.verifiedDevices ?? []"
        [certifiedPlantUninstalledDevices]="resolved.selectedSystemDefinition?.metadata?.verifiedUninstallations ?? []"
        [connextDevicesConfig]="data.connextDevicesConfig"
        [connextSerial]="data.connextSerial"
        [applyChangeToCertifiedPlant]="resolved.selectedSystemDefinition?.source === 'aws' ? resolved.selectedSystemDefinition?.uid : ''"
        [is3PhasePlant]="data.is3PhasePlant"
        [system]="system">
      </customer-connext-devices-section>
    </section>
  </ng-template>

  <ng-template
    #virtualDevices
    let-data>
    <section class="custom-block">
      <ng-container *ngTemplateOutlet="header; context: { title: labels.modifyPlant }"></ng-container>
      <customer-virtual-devices-section
        class="mt-3"
        [labels]="{
          active: labels.active,
          addInverter: labels.addInverter,
          atLeastOneActiveInverter: labels.atLeastOneActiveInverter,
          attention: labels.attention,
          delete: labels.delete,
          deviceAlreadyOnACertifiedPlant: labels.deviceAlreadyOnACertifiedPlant,
          deviceNotExist: labels.deviceNotExist,
          inverterListDescription: labels.inverterVirtualListDescription,
          inverterListPlaceholder: labels.inverterListPlaceholder,
          inverterListTitle: labels.inverterListTitle,
          serialNotValid: labels.serialNotValid,
          thereAreUnsavedChanges: labels.thereAreUnsavedChanges,
          uninstall: labels.uninstall,
          uniqueSerial: labels.uniqueSerial,
          validationError: labels.validationError,
        }"
        [virtualDevicesConfig]="data.virtualDevicesConfig"
        [internalManagement]="system?.source === 'aws'">
      </customer-virtual-devices-section>
      <button
        class="custom-mat-button-primary mt-3"
        data-testid="devices-save-button"
        mat-button
        mat-dialog-close
        [disabled]="isVirtualDevicesConfigInvalid"
        (click)="resolved.selectedSystemDefinition && updatePlant(resolved.selectedSystemDefinition)">
        {{ labels.save }}
      </button>
    </section>
  </ng-template>

  <ng-template
    #azzurroHubDevices
    let-data>
    <section class="custom-block">
      <ng-container *ngTemplateOutlet="header; context: { title: labels.modifyPlant }"></ng-container>
      <customer-azzurro-hub-devices-section
        class="mt-3"
        [labels]="{
          addDevice: labels.addDevice,
          addedDevice: labels.addedDevice,
          detectedDevices: labels.detectedDevices,
          deviceListContent: labels.deviceListContent,
          detectedDevicesDescription: labels.detectedDevicesDescription,
          manualDeviceList: labels.manualDeviceList,
          manualDeviceListDescription: labels.manualDeviceListDescription,
          manualDeviceListPlaceholder: labels.manualDeviceListPlaceholder,
          noDetectedDevices: labels.noDetectedDevices,
          noAddedDevices: labels.noAddedDevices,
          noAddedDevicesDescription: labels.noAddedDevicesDescription,
          advanced: labels.advanced,
          advancedDescription: labels.advancedDescription,
          azzurroHubOffline: labels.azzurroHubOffline,
          devicesAddedToAdvancedPlant: labels.devicesAddedToAdvancedPlant,
          clickToAddToYourPlant: labels.clickToAddToYourPlant,
          scanning: labels.scanning,
          listFoundDevices: labels.listFoundDevices,
          startRescan: labels.startRescan,
          refreshDevices: labels.refreshDevices,
          deviceNotExist: labels.deviceNotExist,
          deviceAlreadyOnACertifiedPlant: labels.deviceAlreadyOnACertifiedPlant,
          serialNotValid: labels.serialNotValid,
          validationError: labels.validationError,
        }"
        [azzurroHubSerial]="data.azzurroHubSerial"
        [deviceValidators]="data.deviceValidators"
        [existingDevices]="data.existingDevices"
        [isVerifiedMode]="data.isVerifiedMode"
        [system]="resolved.selectedSystemDefinition ?? undefined"
        [emitCompleteData]="true"
        (devicesChange)="updateAzzurroHubDevicesConfig($event)">
      </customer-azzurro-hub-devices-section>
      <button
        class="custom-mat-button-primary mt-3"
        data-testid="azzurro-hub-devices-save-button"
        mat-button
        mat-dialog-close
        [disabled]="isAzzurroHubDevicesConfigInvalid"
        (click)="resolved.selectedSystemDefinition && updatePlant(resolved.selectedSystemDefinition)">
        {{ labels.save }}
      </button>
    </section>
  </ng-template>
</ng-container>

<ng-template
  #header
  let-title="title">
  <header class="fx-row bg-grey-100 px-3 mx-n-3 mt-n-3 pt-3 pb-1">
    <span class="tw-text-base tw-font-medium text-grey-400">
      {{ title }}
    </span>
    <button mat-dialog-close>
      <mat-icon class="text-grey-400">close</mat-icon>
    </button>
  </header>
</ng-template>
